
  <mat-sidenav-container fullscreen>

    <mat-sidenav style="width:250px;" #sidenav [opened]="!isMobile" [mode]="isMobile ?'over':'side'" >
      <div fxLayout="column" fxFill>
        <mat-nav-list>
          <mat-list-item><h2 class="mat-h2">Menu</h2></mat-list-item>
          <mat-divider></mat-divider>

          <mat-list-item routerLink="">
            <a>Home</a>
          </mat-list-item>
          <mat-list-item routerLink="/dash/how-to-use-apis">
            <a>How to use APIs</a>
          </mat-list-item>
          <mat-list-item routerLink="/dash/api-tutorial/index" class="mat-list-sub-item">
            <a>&raquo; API Tutorial</a>
          </mat-list-item>
          <mat-divider></mat-divider>

          <mat-list-item style="background-color: #fafafa;">
            <div>APIs</div>
          </mat-list-item>
          <mat-divider></mat-divider>

          <app-api-list-items></app-api-list-items>

        </mat-nav-list>

        <div fxFlex></div>
        <mat-card>
          <mat-card-content>
            <p>&copy; {{currentYear}} Telmar</p>
            <span class="version">v{{appVersion}}</span>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>

      <div fxLayout="column" fxFlex fxFill>
        <mat-toolbar fxLayout="row" fxLayoutGap="2px" class="mat-elevation-z4" style="z-index:99;">
          <button mat-icon-button color="primary" (click)="sidenav.toggle()" [fxShow]="isMobile" >
            <mat-icon *ngIf="sidenav.opened">chevron_left</mat-icon>
            <mat-icon *ngIf="!sidenav.opened">chevron_right</mat-icon>
          </button>
          <mat-icon class="material-icons-outlined main-idea">emoji_objects</mat-icon>
          <h2>Telmar<span fxHide fxShow.gt-xs> : // Developer</span></h2>
          <div fxFlex>&nbsp;</div>
          <tup-account-menu></tup-account-menu>
        </mat-toolbar>

        <div class="main-content" fxFlex style="overflow-y:auto;">
          <router-outlet></router-outlet>
        </div>

      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>
